import { ref } from 'vue'

// Shared state at module level - ensures all callers share the same isOpen state
const isOpen = ref(false)

// Store the keyboard handler so we can remove it during HMR
let keyboardHandler: ((e: KeyboardEvent) => void) | null = null

// Keyboard shortcut handler function
const handleKeyDown = (e: KeyboardEvent) => {
  if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
    e.preventDefault()
    isOpen.value = !isOpen.value
  }
}

// Register the keyboard listener once at module load
// This ensures it works regardless of component mount timing
if (typeof window !== 'undefined') {
  // Clean up any existing handler first (for HMR)
  if (keyboardHandler) {
    window.removeEventListener('keydown', keyboardHandler)
  }
  keyboardHandler = handleKeyDown
  window.addEventListener('keydown', keyboardHandler)
}

// Support HMR cleanup
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    if (keyboardHandler) {
      window.removeEventListener('keydown', keyboardHandler)
      keyboardHandler = null
    }
  })
}

export const useCommandPalette = () => {
  const open = () => {
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
  }

  const toggle = () => {
    isOpen.value = !isOpen.value
  }

  return {
    isOpen,
    open,
    close,
    toggle
  }
}